<script>
  import { VideoIcon } from "svelte-feather-icons";
</script>

<div class="flex justify-center items-center text-gray-400 h-full">
  <VideoIcon size="5x" />
</div>